// tslint:disable: completed-docs

import { ExtractActions, triggerOverlay } from '@vfde-fe/sails_core';
import {
    CREATE_INITIAL_STATE,
    GET_DEVICE_FAILED,
    GET_DEVICE_SUCCESS,
    SET_DEFAULT_STATE,
    SHOW_LOADING,
    TOGGLE_HARDWARE_ONLY,
    TRIGGER_GIGAKOMBI_OVERLAY,
    TOGGLE_INSURANCE,
    TOGGLE_TRADE_IN,
    TRIGGER_TRADE_IN_TRACKING,
    GO_TO_BASKET,
    HANDLE_PAGESHOW,
} from './constants';
import { HardwareDetailsResponse, HardwareDetailsResponseError } from './interfaces/api';

/**
 * createInitialState
 */
const createInitialState = (actions: {
    goToBasket: typeof goToBasket,
}) => ({
    type: CREATE_INITIAL_STATE,
    actions,
});

/**
 * Set default state
 * @param isHardwareOnly
 * @param insurance
 * @param isTradeIn
 * @param isTauschbonus
 */
const setDefaultState = (
    isHardwareOnly: boolean,
    insurance: boolean,
    isTradeIn: boolean,
    isTauschbonus: boolean,
) => ({
    type: SET_DEFAULT_STATE,
    isHardwareOnly,
    insurance,
    isTradeIn,
    isTauschbonus,
});

/**
 * Fire when API request success
 */
const showLoading = () => ({
    type: SHOW_LOADING,
});

/**
 * Fire when API request success
 * @param payload
 */
const getDeviceSuccess = (payload: HardwareDetailsResponse) => ({
    type: GET_DEVICE_SUCCESS,
    payload,
});

/**
 * Fire when API request fails
 * @param error
 */
const getDeviceFailed = (error: HardwareDetailsResponseError) => ({
    type: GET_DEVICE_FAILED,
    error,
});

/**
 * Fire when user enters or leaves hardware flow
 * @param
 */
const toggleHardwareOnly = () => ({
    type: TOGGLE_HARDWARE_ONLY,
});

/**
 * createInitialState
 */
const triggerGigaKombiOverlay = () => ({
    type: TRIGGER_GIGAKOMBI_OVERLAY,
});

/**
 * Fire when user select/deselect device insurance
 * @param isChecked
 * @param trackIt
 * @param forceRerender
 */
const toggleInsurance = (isChecked: boolean, trackIt = false, forceRerender = true) => ({
    type: TOGGLE_INSURANCE,
    isChecked,
    trackIt,
    forceRerender,
});

/**
 * Toggle trade in
 */
const toggleTradeIn = (force?: boolean) => ({
    type: TOGGLE_TRADE_IN,
    force,
});

/**
 * Trigger trade in switch option tracking
 */
const triggerTradeInTracking = () => ({
    type: TRIGGER_TRADE_IN_TRACKING,
});

/**
 * Go To Basket
 */
const goToBasket = () => ({
    type: GO_TO_BASKET,
});

/**
 * Handle pageshow event
 */
const handlePageShow = (event: PageTransitionEvent) => ({
    type: HANDLE_PAGESHOW,
    event,
});

/**
 * Action Creators Object
 */
export const deviceDetailActionCreators = {
    createInitialState,
    setDefaultState,
    showLoading,
    getDeviceSuccess,
    getDeviceFailed,
    toggleHardwareOnly,
    triggerGigaKombiOverlay,
    toggleInsurance,
    toggleTradeIn,
    triggerTradeInTracking,
    goToBasket,
    handlePageShow,
};

/**
 * Action Dispatchers Object
 */
export const deviceDetailActionDispatchers = {
    createInitialState,
    toggleHardwareOnly,
    toggleInsurance,
    triggerOverlay,
    toggleTradeIn,
    goToBasket,
    triggerTradeInTracking,
    triggerGigaKombiOverlay,
    handlePageShow,
};

/**
 * Action Creators
 */
export type DeviceDetailActionCreators = typeof deviceDetailActionCreators;

/**
 * Action Dispatchers
 */
export type DeviceDetailActionDispatchers = typeof deviceDetailActionDispatchers;

/**
 * Union Action Type
 */
export type DeviceDetailAction = ExtractActions<DeviceDetailActionCreators>;
